/**
 * calculates the number of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.
 *
 * @param {number} interestRate
 * @param {number} monthlyPaymentAmount
 * @param {number} currentBalance
 * @returns {number} the number of months to pay off balance
 */
export default function calculateNPER({ interestRate, monthlyPaymentAmount, currentBalance }) {
    if (!interestRate || !monthlyPaymentAmount || !currentBalance) {
        return null;
    }

    const rate = interestRate / 100;

    // Formula for NPER found here: https://onecompiler.com/javascript/3x2vaca4k
    const nper1 = Math.log((1 - ((currentBalance / monthlyPaymentAmount) * (rate / 12))));
    const nper2 = Math.log((1 + (rate / 12)));

    return -(nper1 / nper2);
}